<div class="grid__col-12 guts-p-full-0 guts-m-b-2">
  <p *ngIf="linkTextRow?.linkTextValue" class="par break">
    {{ linkTextRow?.linkTextValue }}
  </p>
</div>
<a
  df-button
  dfButtonType="primary"
  [href]="linkTextRow?.link"
  (click)="trackClick()"
  target="_blank"
  data-dgat="flexRow-5e3"
>
  <span class="break">{{ linkTextRow?.label }}</span>
  <df-icon
    icon="arrow-up-right-out"
    class="color-white guts-m-l-half"
  ></df-icon>
</a>
